﻿import DOMPurify from 'dompurify';

export function sanitize(content) {
    return DOMPurify.sanitize(content);
}